import React from 'react';

const Question = ({ content }) => (
  <div
    className="new-exam__body__header"
    // style={{ 'line-height': '110%' }}
  >
    {content}
  </div>
);

export default Question;



// WEBPACK FOOTER //
// ./src/components/NewExam/Question.js